var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConverted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#converted)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E0E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475569",
    d: "M7.125 5.813a.437.437 0 1 0 0 .875h2.444l-.566.565a.438.438 0 0 0 .619.619l1.312-1.313a.438.438 0 0 0 0-.618L9.622 4.628a.438.438 0 0 0-.619.619l.566.566H7.125ZM8.875 10.188a.437.437 0 1 0 0-.876H6.431l.566-.565a.438.438 0 0 0-.619-.619L5.066 9.441a.437.437 0 0 0 0 .618l1.312 1.313a.438.438 0 0 0 .619-.619l-.566-.566h2.444Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "converted"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverted);
export default __webpack_public_path__ + "static/media/converted.28820fcc0078e2b1dda967c33e001ef2.svg";
export { ForwardRef as ReactComponent };